import { useRootAppStore } from "@hooks";
import { ChatViewStore } from "@state/stores/chat/ChatViewStore";
import { FormButton } from "@components/buttons";
import { FormInputField } from "@components-shared/desktop/inputs";
import { observer } from "mobx-react";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default observer(function ChatNameForm({
	store,
}: {
	store: ChatViewStore;
}) {
	const methods = useForm({
		mode: "onChange",
		defaultValues: {
			chatName: "",
		},
	});
	const { t } = useTranslation();
	const { handleSubmit } = methods;
	const rootStore = useRootAppStore();
	const submitData = async (chatName: string) => {
		if (rootStore.userAuthStore.user) {
			await store.updateChatName(chatName);
		}
	};
	return (
		<div className="chat__box">
			<div className="chat__notice">
				<div className="chat__box__icon-wrapper">
					<i className="u-icon u-icon--xlrg u-icon--user--alt" />
				</div>

				<div className="u-type--center">
					<div className="u-type--sml">
						{t("CHAT.ENTER_CHAT_NAME_DESCRIPTION")}
					</div>
				</div>
			</div>

			<FormProvider {...methods}>
				<form
					className="chat__footer"
					onSubmit={handleSubmit((formData: { chatName: string }) =>
						submitData(formData.chatName)
					)}
				>
					<div className="chat__textbox">
						<FormInputField
							name="chatName"
							type="string"
							placeholder={t("CHAT.ENTER_CHAT_NAME_PLACEHOLDER")}
							inputClassName="chat__input input input--sml"
							maxLength={27}
							validate={{
								nameContainsUnderscore: (value: string) =>
									!value.includes("_") ||
									"CHAT.CANNOT_CONTAIN_UNDERSCORE",
							}}
							required
						/>

						<FormButton
							btnText={t("COMMON.SAVE")}
							className="chat__send btn btn--sml btn--accent"
						/>
					</div>
				</form>
			</FormProvider>
		</div>
	);
});
